import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

import {
  PATH_COST_DEFAULT,
  PATH_COSTS,
} from '../../app/constants/paths.constant';
import { Breadcrumbs } from '../../components/Breadcrumbs';
import { Loading } from '../../components/Loading';
import { useIdParam } from '../../utils/use-id-param.util';
import { Page } from '../../contexts/NavigationContext/enums/page.enum';
import { useNavigationContext } from '../../contexts/NavigationContext/hooks/useNavigationContext.hook';
import { useBuildPath } from '../../hooks/useBuildPath.hook';
import { buildDocumentTitle } from '../../utils/document-title.util';
import { PageTitle } from '../../components/PageTitle';

import { CostTabs } from './Tabs';
import { useFindOneCostQuery } from './hooks/useFindOneCostQuery.hook';

export const CostPage = () => {
  const { setPage } = useNavigationContext();
  const id = useIdParam();

  const path = useBuildPath(PATH_COST_DEFAULT, { id });

  const { data, isSuccess } = useFindOneCostQuery(id);

  useEffect(() => {
    setPage(Page.Costs);
  }, [setPage]);

  const beforeTitleContent = (
    <>
      <Helmet>
        <title>
          {buildDocumentTitle('Fiche Coût', data?.findOneCost.code)}
        </title>
      </Helmet>
      <Breadcrumbs
        paths={[
          {
            to: PATH_COSTS,
            label: 'coûts',
            key: 'costs',
          },
          {
            to: path,
            label: 'fiche',
            key: 'cost',
          },
        ]}
      />
    </>
  );

  const titleContent = <PageTitle title="Fiche Coût" />;

  if (isSuccess) {
    const cost = data.findOneCost;

    return (
      <>
        {beforeTitleContent}
        <PageTitle code={cost.code} title={cost.label} />
        <CostTabs cost={cost} />
      </>
    );
  }

  return (
    <>
      <Loading />
      {beforeTitleContent}
      {titleContent}
    </>
  );
};
